<template>
  <div class="mx-3">
    <v-row>
      <v-col
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <setup-job-position-job-category-dialog-create
          v-if="$hasPermissionTo(['create job categories'])" 
          @created="loadData"
        />
      </v-col>
      <v-spacer />

      <v-col
        class="py-0"
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <v-select
          v-model="statusFilter"
          :items="items"
          item-text="state"
          item-value="value"
          label="Job Category's Status"
          placeholder="Active / Deleted"
        />
      </v-col>

      <v-col
        class="py-0"
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <v-text-field
          v-model="search"
          placeholder="Key in job category value here"
          append-icon="search"
          label="Search Job Category"
          hide-no-data
          hide-selected
          clearable 
        />
      </v-col>
    </v-row>
  
    <v-data-table
      :headers="headers"
      :items="filteredJobCategories"
      :loading="tableLoading"
      :search="search"
    >
      <template v-slot:item.name="{ item }">
        <div>
          <span>{{ item.name }}</span>
        </div>
      </template>
           
      <template v-slot:item.action="{ item }">
        <span v-if="statusFilter">
          <setup-job-position-job-category-dialog-edit
            v-if="$hasPermissionTo(['update job categories'])" 
            :job-category="item"
            @updated="loadData"
          />
          <span class="mx-1" />
          <setup-job-position-job-category-dialog-delete
            v-if="$hasPermissionTo(['delete job categories'])" 
            :job-category="item"
            @deleted="loadData"
          />
        </span>
        <span v-else>
          <setup-job-position-job-category-dialog-restore
            v-if="$hasPermissionTo(['restore job categories'])" 
            :job-category="item"
            @restored="loadData"
          />
        </span>
      </template> 
    </v-data-table>
  </div>
</template>

<script>
  export default {
    components: {
      SetupJobPositionJobCategoryDialogCreate: () => import('@/components/hris/setup/job-position/job-category/DialogCreate'),
      SetupJobPositionJobCategoryDialogDelete: () => import('@/components/hris/setup/job-position/job-category/DialogDelete'),
      SetupJobPositionJobCategoryDialogRestore: () => import('@/components/hris/setup/job-position/job-category/DialogRestore'),
      SetupJobPositionJobCategoryDialogEdit: () => import('@/components/hris/setup/job-position/job-category/DialogEdit'),
    },
    data () {
      return {
        jobCategories: [],
        trashedJobCategories: [],
        headers: [
          {
            text: 'Name',
            align: 'left',
            value: 'name',
          },
          {
            text: '',
            sortable: false,
            value: 'action',
          },
        ],
        search: '',
        statusFilter: { state: 'Active', value: true },
        items: [
          { state: 'Active', value: true },
          { state: 'Deleted', value: false },
        ],
        tableLoading: true,
      }
    },
    computed: {
      filteredJobCategories () {
        return this.statusFilter ? this.jobCategories : this.trashedJobCategories
      },
    },
    created () {
      this.loadData()
    },
    methods: {
      loadData () {
        Promise.all([
          this.$api.jobCategories().list(),
          this.$api.jobCategories().listTrashed(),
        ]).then(([jobCategories, trashedJobCategories]) => {
          this.jobCategories = jobCategories.data
          this.trashedJobCategories = trashedJobCategories.data

          this.tableLoading = false
        })
      },
    },
  }
</script>
